import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { connect } from 'react-redux';

import { saveAccountReviewComments, getStorageSetting } from 'actions';

import AccessControl from 'components/AccessControl';
import ActivityPerms from 'components/AccessControl/permissions.json';

import FormWorkflowStages from 'common/Workflows/FormWorkflowStages';

class FormReviewerCommentsSection extends Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    permissions: PropTypes.arrayOf(PropTypes.string),
    formId: PropTypes.number,
    accountId: PropTypes.number,
    formReviewState: PropTypes.shape(),
    workflowState: PropTypes.shape(),
    validReviewer: PropTypes.bool,
    isLocked: PropTypes.bool,
    isSavingFormReviewState: PropTypes.bool,
    hasValidationResult: PropTypes.bool
  };

  static defaultProps = {
    permissions: null,
    formId: null,
    accountId: null,
    formReviewState: null,
    workflowState: null,
    validReviewer: true,
    isLocked: false,
    isSavingFormReviewState: false,
    hasValidationResult: false
  };

  constructor(props) {
    super(props);

    let draftComments = '';
    let previousComments = null;
    if (props.accountId && props.formReviewState && props.formReviewState.accountComments) {
      const matched = props.formReviewState.accountComments.filter(f => f.accountId === props.accountId);
      if (matched && matched.length > 0) {
        draftComments = matched[0].draftComments;
        previousComments = matched[0].previousComments;
      }
    }

    this.state = {
      draftComments,
      previousComments
    };
  }

  onDraftCommentsChange = e => this.setState({ draftComments: e.target.value });

  onCopyAllPreviousComments = () => {
    const { previousComments } = this.state;

    if (previousComments) {
      const copiedComments = previousComments.join('\n');
      this.setState({ draftComments: copiedComments });
    }
  };

  onCopyComment = (comment) => {
    this.setState({ draftComments: comment.comm });
  };

  onFormSubmit = () => {
    const { dispatch, formId, accountId } = this.props;
    const { draftComments } = this.state;

    dispatch(saveAccountReviewComments(formId, accountId, draftComments));
  };

  getReviewerStage() {
    const { formReviewState } = this.props;

    if (formReviewState != null) {
      if (formReviewState.workflowStage >= 4 && formReviewState.workflowStage <= 5) {
        return 'Initial Reviewer';
      }
      if (formReviewState.workflowStage >= 6 && formReviewState.workflowStage <= 7) {
        return 'Secondary Reviewer';
      }
      if (formReviewState.workflowStage >= 8 && formReviewState.workflowStage <= 9) {
        return 'Expert Reviewer';
      }
    }
    return 'My';
  }

  canComment() {
    const { permissions, formReviewState, workflowState, validReviewer, isLocked } = this.props;
    if (!validReviewer || isLocked) {
      return false;
    }

    const isUserFormOwner = workflowState != null && workflowState.assignedUser === getStorageSetting('username');
    const hasReviewerPermission = AccessControl.hasPermission(permissions, [ActivityPerms.fwfInitialReviewer, ActivityPerms.fwfSecondaryReviewer, ActivityPerms.fwfExpertReviewer, ActivityPerms.fwfSupplReviewer]);

    if (formReviewState != null && formReviewState.workflowStage != null) {
      if (formReviewState.workflowStage === FormWorkflowStages.BatchStaging) {
        // WF is Batch Staging
        return false;
      }
      if (formReviewState.workflowStage === FormWorkflowStages.Complete) {
        // WF is complete
        return AccessControl.hasPermission(permissions, [ActivityPerms.fwfExpertReviewer, ActivityPerms.fwfSupplReviewer]);
      }
    }
    return isUserFormOwner && hasReviewerPermission;
  }

  render() {
    const { isSavingFormReviewState } = this.props;
    const { draftComments, previousComments } = this.state;
    return (
      <div className="reviewer-comments">
        <h1>Reviewer Comments</h1>
        <div className="reviewer-comments-content">
          <div className="previous-comments col-12">
            <label htmlFor="previous-comments" className="form-label"><strong>Previous Reviewer(s) Comment(s)</strong></label>
            { (!previousComments || previousComments.length === 0) && <span>No comments made.</span> }
            { // eslint-disable-next-line
              previousComments && previousComments.length > 0 && previousComments.map((comm, index) => comm != null && <p key={ index }>
                { this.canComment() && <button
                  className="btn btn-sm copy-icon"
                  type="button"
                  title="Copy comment"
                  onClick={ () => this.onCopyComment({ comm }) }
                >
                  <span className="icon icon-copy" />
                </button> }
                { // eslint-disable-next-line
                  comm != null && comm.split('\n') && comm.split('\n').map((item, index) => item != null && <span key={ index }>{ item }<br /></span>) 
                }</p>)
            }
          </div>
          { this.canComment() && <div className="col-12 mt-10">
            <label htmlFor="reviewer-comments" className="form-label comments-title">
              <strong>{ this.getReviewerStage() } Comments</strong>
              { previousComments && previousComments.length > 0
                && <button type="button" className="btn btn-primary" onClick={ () => this.onCopyAllPreviousComments() }>Copy All</button> }
            </label>
            <p>Insert in the box any additional information supplied or sourced.</p>
            <textarea
              id="reviewer-comments"
              name="reviewerComment"
              { ... { rows: '10', maxLength: '2000' } }
              className="form-input"
              value={ draftComments }
              onChange={ (e, value) => this.onDraftCommentsChange(e, value) }
            />
            <button
              id="save-comments"
              type="button"
              className="btn btn-primary mt-10 col-12"
              disabled={ isSavingFormReviewState }
              onClick={ () => this.onFormSubmit() }
            >
              { isSavingFormReviewState && <span className="icon loading mr" /> }
              Save
            </button>
          </div> }
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const {
    auth: {
      permissions
    },
    forms: {
      isSavingFormReviewState,
      formReviewState,
      workflowState
    }
  } = state;

  return {
    permissions,
    isSavingFormReviewState,
    formReviewState,
    workflowState
  };
}

const mapDispatchToProps = dispatch => ({ dispatch });

export const FormReviewerComments = connect(
  mapStateToProps,
  mapDispatchToProps
)(FormReviewerCommentsSection);

export default FormReviewerComments;
